import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { LoaderService } from '@app/core/business/ui/loader.service';
import { Observable, throwError } from 'rxjs';

// ⏳ Gestion affichage loader global
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private excludedRequests: RegExp[] = [
    /\/companies\/.*\/products\/.*\/availability$/,
    /\/companies\/.*\/customers\/.*\/deliveryDates$/,
    /\/companies\/.*\/ad$/,
    /\/companies\/.*\/ad\/location/,
    /\/companies\/.*\/advertisements\/.*$/,
    /\/companies\/.*\/customers\/.*\/claims\/reasons$/,
    /\/companies\/.*\/customers\/.*\/orders$/,
    /\/companies\/.*\/customers\/.*\/orders\/.*\/pdf$/,
    /\/companies\/.*\/customers\/.*\/delivery-notes\/.*\/pdf$/,
    /\/companies\/.*\/customers\/.*\/invoices\/.*\/pdf$/,
    /\/companies\/.*\/OnlinePaymentInfos$/,
    /\/companies\/.*\/Offers\/Favorites$/,
    /\/companies\/.*\/availability$/,
    /\/companies\/.*\/availabilityDC$/,
    /\*skipLoading=true*$/,
    /\.*no-loader\/.*/
  ];

  constructor(private loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If request isn't excluded
    if ((req.method === 'GET' && this.testRequest(req)) || this.forcedLoad(req)) {
      return Observable.create(observer => {
        if (this.forcedLoad(req)) {
          req = req.clone({
            params: new HttpParams({
              fromString: req.params
                .toString()
                .replace(/\?forceLoading=true|&forceLoading=true/g, ''),
            }),
          });
        }
        this.requests.push(req);
        this.loaderService.isLoading.next(true);

        const subscription = next.handle(req).subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          }
        );

        return () => {
          this.removeRequest(req);
          subscription.unsubscribe();
        };
      });
    }

    return next.handle(req);
  }

  private forcedLoad(req: HttpRequest<any>) {
    if (req.urlWithParams.includes('forceLoading=true')) {
      return true;
    }
    return false;
  }

  private testRequest(req: HttpRequest<any>) {
    return !this.excludedRequests.some(excluded => {
      return req.url.search(excluded) !== -1;
    });
  }

  private removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i > -1) {
      this.requests.splice(i, 1);
      this.loaderService.isLoading.next(this.requests.length > 0);
    }
  }
}
